module.exports = __webpack_public_path__ + "img/Icono_RGB-01.ffeb6473.png";